query dashboard($from: Date, $to: Date) {
  analytics(from: $from, to: $to) {
    id
    newUsers {
      id
      emailAddress
      joinedAt
      ipAddressCountry
    }
    savedProjects {
      id
      createdAt
      userId
      mediumImage
    }
    cartProjects {
      id
      createdAt
      userId
      mediumImage
    }
    orderedProjects {
      id
      createdAt
      userId
      mediumImage
    }
  }
}
